import { render, staticRenderFns } from "./ExistingCriteriaList.vue?vue&type=template&id=e56f9692"
import script from "./ExistingCriteriaList.vue?vue&type=script&lang=ts"
export * from "./ExistingCriteriaList.vue?vue&type=script&lang=ts"
import style0 from "./ExistingCriteriaList.vue?vue&type=style&index=0&id=e56f9692&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports